import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { Organization, Query } from '../generated';
import { RcApiService } from './rc-api.service';

@Injectable()
export class OrganizationService {
  constructor(private rcApiService: RcApiService) {}

  public getOrganizations(): Observable<Array<Organization>> {
    return this.rcApiService.apollo
      .query<Query>({
        query: gql`
          query GetOrganizations {
            listOrganizations {
              id
              name
              createdAt
              updatedAt
              members {
                user {
                  id
                  name
                  email
                }
                isAdmin
              }
              properties {
                id
                address
                createdAt
                updatedAt
                units {
                  id
                  name
                }
              }
            }
          }
        `,
      })
      .pipe(map((result) => result?.data?.listOrganizations || []));
  }
}
